import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ResultsComponent } from './results.component';
import { MaterialModule } from '../../material.module';
import { BannerZoneMapModule } from 'src/app/Components/banner-zone-map/baner-zone-map.module';

const routes: Routes = [
    {
        path: '',
        component: ResultsComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ResultsRoutingModule { }

@NgModule({
    imports: [
        CommonModule,
        ResultsRoutingModule,
        MaterialModule,
        BannerZoneMapModule
    ],
    declarations: [ResultsComponent,],
    exports: [ResultsComponent]
})
export class ResultsModules { }